import { Row, Col } from "antd";
import { Card, Icon, LoadingSpinner, Modal, Button, ButtonGroup, Tooltip } from 'pepsico-ds'
import SmartCubeTable from "../Table/SmartCubeTable.js"
import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import ModalFilters from './ModalFilters';
import NoData from '../NoData/NoData'
import SupplierPerfTable from "../Table/SupplierPerfTable.js"
import { returnHyphenIfNull, formatNumberWithCommas, handleDomToImgDownloadPdf } from '../../utils/utils'
import { localStoreKeys } from '../../constants/localStoreKeys';
import { urlConstants } from '../../constants/urlConstants';
import InfoIcon from "../Icons/InfoIcon.js";
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import CustomButtons from "../Cards/CustomButtons.js";
import DropdownWithIcons from "./DropdownWithIcons.js";
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';


function SmartCubeModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters, appName }) {
    const [smartCubeData, setSmartCubeData] = useState(null)
    const [loader, setLoader] = useState(false)
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const [apps, setApps] = useState([])
    const [dataLoadActionType, setDataLoadActionType] = useState("");
    const dispatch = useDispatch();
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);
    
        useEffect(() => {
            if (openModal) {
                try {
                    trackModalView(`${capability} ${appName}`, 'view');
                } catch (error) {
                    // Silent fail for tracking errors to not disrupt user experience
                }
            }
        }, [openModal, appName, capability]);
    
        const handleClose = () => {
            try {
                trackModalView(`${capability} ${appName}`, 'close');
            } catch (error) {
                // Silent fail for tracking errors
            }
            setOpenModal(false);
            setDataLoadActionType("")
        };

    
    const getSmartCubeDataFromFilters = (value) => {
        // console.log("coMan Data", value);
        setSmartCubeData(value.data)
        setLoader(value.loader);
        setDataLoadActionType(value?.data?.type)
        const appList = value.data?.apps
        // setApps(apps)
        if (appList && appList.length > 0) {
            const tempbuttonGroupItems = [
                
               { icon: "ondemand_video", label: "", onClick: () => window.open(urlConstants.smartCubeVideo, "_blank") },
               // { icon: "interpreter_mode", label: "", onClick: () => console.log("clicked") },
                ...appList
                .filter(item => item.isActive)
                .map(item => ({
                    label: item.app,
                    onClick: () => window.open(item.url, "_blank"),
                }))];

            setButtonGroupItems(tempbuttonGroupItems)
        }
    }

    const smartCubeRef = useRef()
    const smartTableRef = useRef()

    const { showToast } = useToast();


    
    const checkPDFDownloaded = () => {}
    

    const year = smartCubeData?.year;
    const reportCount = smartCubeData?.reportCount;
    const tableData = smartCubeData?.categoryWiseData;
    const isEDFIntegrated = smartCubeData?.edfintegrated;
    const appOwnersList = smartCubeData?.owners
    const emailList = appOwnersList?.map(contact => contact.emailId).join(', ');

    return (
        <Modal
           // onCloseModal={() => setOpenModal(!openModal)}
            onCloseModal={handleClose}
            primaryButtonProps={{
                //onClick: () => setOpenModal(!openModal),
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            closeOnOutsideClick={false}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(`${capability} ${appName}`)}
        >
            <div ref={smartCubeRef}>
                <div className="modal-title" style={{ fontWeight: 700, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>
                        SmartCube Amplifi Pro
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>
                    {
                        loader ? (
                            <></>
                        ) :                    
                        <>
                            {/* <ButtonGroup
                                style={{ marginRight: '2rem' }}
                                className="buy-con-button-group"
                                items={buttonGroupItems}
                                size="small"
                            /> */}
                            
                        
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <CustomButtons isModal={true} appList={
                                [
                                    { icon: 'ondemand_video', label: '', "url": "https://www.youtube.com/watch?v=Xcw4musvtFA", },
                                    ...(smartCubeData?.apps ?? [])
                                ]
                            }   
                            />
                            {/* <button onClick={() => handleDomToImgDownloadPdf(smartCubeRef, "SmartCube_Modal")}>PDF</button> */}
                                <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}>
                                    <DropdownWithIcons modalRef={smartCubeRef} kpiName={"SmartCube_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded}/>
                                </span>
                            </span>
                        
                        
                        </>
                    }
                </div>
                <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(smartCubeData?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(smartCubeData?.refreshFrequency)}</div>
                <ModalFilters modalName={"SmartCube"} selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getSmartCubeDataFromFilters} landingPageFilters={landingPageFilters} setLoader={setLoader} appName={appName} />
                <br />
                {
                    (dataLoadActionType!=="SUCCESS_MARKET_INTEL_DETAIL_VIEW_ACTION" || loader || isLoading) ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        :
                        <>
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <div className='smart-cube-card-container'>
                                        <Card style={{ height: "100%" }}>
                                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>

                                                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                                                    <div className="spend-modal-alphanumeric-value">
                                                        <div className='spend-modal-numeric-value' style={{ display: "flex", fontSize: "48px" }}>
                                                            {formatNumberWithCommas(reportCount)}
                                                        </div>
                                                    </div>
                                                    <div className='spend-modal-total-spend-text'>MI Reports on SmartCube</div>
                                                </Col>
                                                <Col xs={24} sm={24} md={1} lg={1} xl={1}>
                                                    <div className="modal-divider-verticle" style={{ height: "100%" }} />
                                                </Col>
                                                <Col xs={24} sm={24} md={19} lg={19} xl={19}>

                                                    <div className='smart-cube-chart-title'>SmartCube Reports Catalogue</div>
                                                    <div style={{ display: "flex", width: "100%", gap: "24px", flexWrap: "nowrap" }}>
                                                        <div className='report-catalogue-detail'>
                                                            <span style={{ fontWeight: 400 }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                    <path d="M9 21.5C9 22.05 9.45 22.5 10 22.5H14C14.55 22.5 15 22.05 15 21.5V20.5H9V21.5ZM12 2.5C8.14 2.5 5 5.64 5 9.5C5 11.88 6.19 13.97 8 15.24V17.5C8 18.05 8.45 18.5 9 18.5H15C15.55 18.5 16 18.05 16 17.5V15.24C17.81 13.97 19 11.88 19 9.5C19 5.64 15.86 2.5 12 2.5ZM14.85 13.6L14 14.2V16.5H10V14.2L9.15 13.6C7.8 12.66 7 11.13 7 9.5C7 6.74 9.24 4.5 12 4.5C14.76 4.5 17 6.74 17 9.5C17 11.13 16.2 12.66 14.85 13.6Z" fill="#616161" />
                                                                </svg>
                                                            </span>
                                                            <div style={{ marginLeft: "8px" }}>Category Intelligence</div>
                                                        </div>
                                                        <div className='report-catalogue-detail'>
                                                            <span style={{ fontWeight: 400 }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                    <path d="M12 6.49L19.53 19.5H4.47L12 6.49ZM12 2.5L1 21.5H23L12 2.5ZM13 16.5H11V18.5H13V16.5ZM13 10.5H11V14.5H13V10.5Z" fill="#3A3A3A" />
                                                                </svg>
                                                            </span>
                                                            <div style={{ marginLeft: "8px" }}>Risk Management</div>
                                                        </div>
                                                        <div className='report-catalogue-detail'>
                                                            <span style={{ fontWeight: 400 }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                    <path d="M11.8003 11.4C9.53031 10.81 8.80031 10.2 8.80031 9.25C8.80031 8.16 9.81031 7.4 11.5003 7.4C13.2803 7.4 13.9403 8.25 14.0003 9.5H16.2103C16.1403 7.78 15.0903 6.2 13.0003 5.69V3.5H10.0003V5.66C8.06031 6.08 6.50031 7.34 6.50031 9.27C6.50031 11.58 8.41031 12.73 11.2003 13.4C13.7003 14 14.2003 14.88 14.2003 15.81C14.2003 16.5 13.7103 17.6 11.5003 17.6C9.44031 17.6 8.63031 16.68 8.52031 15.5H6.32031C6.44031 17.69 8.08031 18.92 10.0003 19.33V21.5H13.0003V19.35C14.9503 18.98 16.5003 17.85 16.5003 15.8C16.5003 12.96 14.0703 11.99 11.8003 11.4Z" fill="#616161" />
                                                                </svg>
                                                            </span>
                                                            <div style={{ marginLeft: "8px" }}>Cost Drivers and Insights</div>
                                                        </div>
                                                        <div className='report-catalogue-detail'>
                                                            <span style={{ fontWeight: 400 }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                    <path d="M20.94 11.5C20.48 7.33 17.17 4.02 13 3.56V1.5H11V3.56C6.83 4.02 3.52 7.33 3.06 11.5H1V13.5H3.06C3.52 17.67 6.83 20.98 11 21.44V23.5H13V21.44C17.17 20.98 20.48 17.67 20.94 13.5H23V11.5H20.94ZM12 19.5C8.13 19.5 5 16.37 5 12.5C5 8.63 8.13 5.5 12 5.5C15.87 5.5 19 8.63 19 12.5C19 16.37 15.87 19.5 12 19.5Z" fill="#616161" />
                                                                </svg>
                                                            </span>
                                                            <div style={{ marginLeft: "8px" }}>Sourcing Insights</div>
                                                        </div>
                                                        <div className='report-catalogue-detail'>
                                                            <span style={{ fontWeight: 400 }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                    <path d="M18 16.5L22 12.5L18 8.5V11.5H12.94C12.6 8.4 10.68 5.78 8 4.45C7.96 2.81 6.64 1.5 5 1.5C3.34 1.5 2 2.84 2 4.5C2 6.16 3.34 7.5 5 7.5C5.95 7.5 6.78 7.05 7.33 6.36C9.23 7.4 10.6 9.27 10.92 11.5H7.82C7.4 10.34 6.3 9.5 5 9.5C3.34 9.5 2 10.84 2 12.5C2 14.16 3.34 15.5 5 15.5C6.3 15.5 7.4 14.66 7.82 13.5H10.92C10.6 15.73 9.23 17.6 7.34 18.64C6.78 17.95 5.95 17.5 5 17.5C3.34 17.5 2 18.84 2 20.5C2 22.16 3.34 23.5 5 23.5C6.64 23.5 7.96 22.19 7.99 20.55C10.67 19.22 12.59 16.6 12.93 13.5H18V16.5Z" fill="#616161" />
                                                                </svg>
                                                            </span>
                                                            <div style={{ marginLeft: "8px" }}>Negotiation Levers</div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </div>
                                </Col>
                            </Row>
                            <br />
                            <Row gutter={[10, 10]} style={{ width: '100%' }}>
                            <div ref={smartTableRef} style={{width: '100%'}}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                {
                                    tableData?.length > 0 ?
                                        <>
                                        <div className="ph-table-wrapper">
                                            <div className="smartcube-table common-table">
                                            {/* <span style={{float: 'right', position: 'relative', top: '3rem', zIndex: '9999', right: '0.25rem'}}>
                                                <DropdownWithIcons modalRef={smartTableRef} kpiName={"SmartCube(SC) Reports and KPIs"} checkPDFDownloaded={checkPDFDownloaded}/>
                                            </span> */}
                                                <SmartCubeTable currentData={tableData} year={year} appList={apps}></SmartCubeTable>
                                                {/* <InfoIcon style={{ position: "absolute", bottom: 20 }} direction="right" text="Market Size data awaited for some categories from SmartCube" /> */}
                                                <div className="modal-update-frequesncy" style={{ position: "absolute", bottom: 2, display: "flex" }}><Icon alt="" icon="info" size="small" /> &nbsp; {"Market Size data awaited for some categories from SmartCube"}</div>
                                            </div>
                                        </div>    
                                        </> : <div className="ph-table-wrapper"><NoData /></div>
                                }
                                </Col>
                            </div>
                            </Row>

                            <br />
                            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                                
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <div className='smart-cube-card-container'>
                                            <Card style={{ height: "100%" }}>
                                                <div className='smart-cube-chart-title'>SmartCube Sector Definitions:</div>

                                                <div style={{ background: "#EFF5FC", width: "100%", display: "flex", padding: "24px" }}>
                                                    <div className="sector-definitions-section">
                                                        <div className="sector-definitions-content" style={{ fontWeight: 700 }}>EMEA (Europe, Middle East, and Africa)</div>
                                                        <div className="sector-definitions-content">•	Europe: Includes Western, Eastern, Central, and Southern European countries such as Germany, France, the United Kingdom, Italy, and Russia.</div>
                                                        <div className="sector-definitions-content">•	Middle East: Includes countries in the Gulf Cooperation Council (GCC) such as Saudi Arabia, UAE, Qatar, as well as others like Israel, Turkey, and Iran.</div>
                                                        <div className="sector-definitions-content">•	Africa: Covers the entire African continent, including countries in Sub-Saharan Africa and North Africa like South Africa, Egypt, and Nigeria.</div>
                                                    </div>

                                                    <div className="modal-divider-verticle" />
                                                    <div className="sector-definitions-section">
                                                        <div className="sector-definitions-section">
                                                            <div className="sector-definitions-content" style={{ fontWeight: 700 }}>LATAM (Latin America)</div>
                                                            <div className="sector-definitions-content">•	South America: Brazil, Argentina, Chile, Colombia, and Peru</div>
                                                            <div className="sector-definitions-content">•	Central America: Mexico, Panama, Costa Rica, and Guatemala</div>
                                                            <div className="sector-definitions-content">•	Caribbean: Dominican Republic, Cuba, and Puerto Rico</div>
                                                        </div>
                                                        <br />

                                                        <div className="sector-definitions-section">
                                                            <div className="sector-definitions-content" style={{ fontWeight: 700 }}>North America</div>
                                                            <div className="sector-definitions-content">•	United States</div>
                                                            <div className="sector-definitions-content">•	Canada</div>
                                                        </div>
                                                    </div>
                                                    <div className="modal-divider-verticle" />
                                                    <div className="sector-definitions-section">
                                                        <div className="sector-definitions-content" style={{ fontWeight: 700 }}>APAC (Asia-Pacific)</div>
                                                        <div className="sector-definitions-content">•	East Asia: China, Japan, South Korea, Taiwan, and Hong Kong</div>
                                                        <div className="sector-definitions-content">•	Southeast Asia: Singapore, Thailand, Malaysia, Indonesia, Philippines, and Vietnam</div>
                                                        <div className="sector-definitions-content">•	South Asia: India, Pakistan, Bangladesh, and Sri Lanka</div>
                                                        <div className="sector-definitions-content">•	Oceania: Australia, New Zealand, and Pacific island nations</div>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>
                                    </Col>
                            </Row>
                        </>
                }
                <br />
                <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                    {
                        appOwnersList?.length > 0 &&
                        <div style={{width: '100%'}}>Please reach out to {appOwnersList?.map((contact, index) => (
                            <React.Fragment key={index}>
                                <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                {index < appOwnersList.length - 1 && ', '}
                            </React.Fragment>
                        ))} for any query on the data displayed.</div>
                    }
                    <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                </div>


                {/* <SupplierPerfTable></SupplierPerfTable><br/> */}
                <br />
                </div>
        </Modal>
    )
}


export default SmartCubeModal